import {
    put, all, select, takeLatest,
} from 'redux-saga/effects';
import _ from 'underscore';

import {
    ACCEPT_ALL_COOKIES,
    getAllCookiesIdsSelector,
    setCookie,
} from '../reduxModules/ConsentManagementPlatform';

export function* callAction() {
    const cookiesIds = yield select(getAllCookiesIdsSelector);
    yield all(_.map(cookiesIds, (cookieId) => (
        put(setCookie(cookieId, true))
    )));
}

export function* watch() {
    yield takeLatest(ACCEPT_ALL_COOKIES, callAction);
}
